// Helpers for the OAuth sign-in pages (OAuthPages.tsx), kept apart so they test without the pages' assets.

/** Neon Auth appends this to the sign-in callback; it is not part of the signed request. */
const SESSION_VERIFIER_PARAM = 'neon_auth_session_verifier';

/** The signed request as Neon Auth sent it: the query without '?' and without the session verifier, untouched otherwise. */
export function oauthQueryOf(search: string): string {
  return search
    .replace(/^\?/, '')
    .split('&')
    .filter((pair) => pair !== '' && !pair.startsWith(`${SESSION_VERIFIER_PARAM}=`))
    .join('&');
}

/** Whether every redirect URI is on the person's own machine (an MCP client such as Claude Code). */
export function onlyLoopback(redirectUris: string[]): boolean {
  return (
    redirectUris.length > 0 &&
    redirectUris.every((uri) => {
      try {
        return ['localhost', '127.0.0.1', '[::1]'].includes(new URL(uri).hostname);
      } catch {
        return false;
      }
    })
  );
}
